var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentActivityTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.036,
    height: 51.25,
    viewBox: "0 0 75.036 51.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recentActivityTime",
    transform: "translate(-1265.25 -509.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hashtag_card",
    "data-name": "Hashtag card",
    transform: "translate(1265.25 509.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16893",
    "data-name": "Group 16893",
    transform: "translate(-158.25 -87.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16892",
    "data-name": "Group 16892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16891",
    "data-name": "Group 16891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M11.192,50H.826V16.618H11.192ZM6,12.065a6.032,6.032,0,1,1,6-6.06A6.054,6.054,0,0,1,6,12.065ZM49.989,50H39.645V33.75c0-3.873-.078-8.839-5.39-8.839-5.39,0-6.215,4.208-6.215,8.56V50H17.685V16.618h9.942v4.554h.145a10.892,10.892,0,0,1,9.808-5.391C48.071,15.781,50,22.69,50,31.663V50Z",
    transform: "translate(158.25 87.25)",
    fill: "#5da9dd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "noun-last-playlist-5339106",
    transform: "translate(1209 497.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11522",
    "data-name": "Path 11522",
    d: "M275.671,152.783a.678.678,0,0,0,0-.927.606.606,0,0,0-.885,0l-6.258,6.556a.678.678,0,0,0,0,.927l6.258,6.556a.606.606,0,0,0,.885,0,.678.678,0,0,0,0-.927l-5.816-6.092Z",
    transform: "translate(-154.581 -110.108)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11523",
    "data-name": "Path 11523",
    d: "M118.143,35C110.884,35,105,41.164,105,48.767s5.884,13.767,13.143,13.767,13.143-6.164,13.143-13.767S125.4,35,118.143,35ZM106.252,48.767c0-6.879,5.324-12.456,11.892-12.456s11.892,5.577,11.892,12.456-5.324,12.456-11.892,12.456S106.252,55.647,106.252,48.767Z",
    fill: "#5da9dd",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActivityTime);
export default __webpack_public_path__ + "static/media/recentActivityTime.deefead2ab49e30dccd5e07f49580aca.svg";
export { ForwardRef as ReactComponent };